import React, { useState } from "react";
import moment from "moment/moment";

import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";

import Standing from "../Standing/Standing";

import { Dialog } from "primereact/dialog";

export default function HoldingCard(props) {
  const item = props.item;
  const [show, setShow] = useState(false);

  var netnewqty, nettotalnewqty, removeminus;

  netnewqty = parseFloat(item.buyqtySharing) - parseFloat(item.sellqtySharing);

  nettotalnewqty = parseFloat(item.buyqty) - parseFloat(item.sellqty);

  if (netnewqty > 0) {
    removeminus = netnewqty;
  } else {
    removeminus = netnewqty.toString().replace("-", "");
  }

  return (
    <li key={item.id} className={`menuContainer addHight text`}>
      <div
        onClick={() => {
          setShow(true);
        }}
        className="menuExchange uppercase"
      >
        <div className={`user_id ${item.type === "fo" ? "small" : null}`}>
          {item.symbol}
        </div>
      </div>
      <div className="menuExpiry">
        {item.type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>

      <div className="menuBuyPrice">
        {parseFloat(item.buyqtySharing)}({parseFloat(item.buyqty)})
      </div>
      <div className="menuBuyPrice">{parseFloat(item.buyavg).toFixed(2)}</div>

      <div className="menuBuyPrice">
        {parseFloat(item.sellqtySharing)}({parseFloat(item.sellqty)})
      </div>

      <div className={`menuBuyPrice`}>{parseFloat(item.sellavg).toFixed(2)}</div>

      <div className={`${netnewqty > 0 ? "buytext" : "selltext"} menuBuyPrice`}>
        {parseFloat(item.netqtySharing).toFixed(2)} ({parseFloat(nettotalnewqty)})
      </div>
      <div className={`menuBuyPrice`}>{parseFloat(item.qty).toFixed(0)}</div>

      <div className="menuBuyPrice ">
        <LiveRate symbol_id={item.symbol_id} netqty={netnewqty} />
      </div>
      <div className="menuBuyQty">
        <ProfitLoss
          netnewqty={netnewqty}
          removeminus={removeminus}
          symbol_id={item.symbol_id}
          item={item}
          total={props.total}
        />
      </div>

      <Dialog
        visible={show}
        closeOnEscape
        closeIcon
        onHide={() => {
          setShow(false);
        }}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Standing item={item} close={() => setShow(false)} />
      </Dialog>
    </li>
  );
}
